__turbopack_context__.v({
  "text-field-box": "mGsXUq_text-field-box",
  "text-field-input": "mGsXUq_text-field-input",
});
